import { SharpeValues, SharpeResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// Sharpe ratio = (Return - Risk-free rate) / Standard deviation
// Inputs are percentages; convert to decimals for calculation, but the ratio is unitless
export function calculateSharpe(values: SharpeValues, t?: ToolsTranslations['sharpeRatio']): SharpeResult {
  const { expectedReturnPercent, riskFreeRatePercent, stdDeviationPercent } = values;

  if (stdDeviationPercent <= 0) return { sharpe: null, isValid: false, message: t?.invalid.stdDeviationPercent };

  const excessReturn = expectedReturnPercent - riskFreeRatePercent; // still percent units
  const sharpe = excessReturn / stdDeviationPercent; // percent cancels out
  const rounded = Math.round(sharpe * 100) / 100; // 2 decimals

  if (!isFinite(rounded)) return { sharpe: null, isValid: false, message: t?.invalid.generic };

  return { sharpe: rounded, isValid: true };
}


